/**
 * Supabase Storage rejects object keys containing characters outside its
 * allowed set with a 400 "Invalid key" — spaces are the common real-world
 * offender (desktop screenshot names like "Screenshot 2026-09-11 at
 * 8.39.11 am.png"). Photo keys are built as `${jobId}/${uuid}_${fileName}`,
 * so only the file-name segment ever needs sanitising; the original name is
 * preserved in the photos.file_name column for display.
 */

/** Replace anything outside the definitely-safe key characters */
export const sanitizeStorageFileName = (name: string): string => {
  const safe = name.replace(/[^\w.-]/g, '_')
  return /[\w]/.test(safe) ? safe : 'photo.jpg'
}

/**
 * Conservative validity check: only characters we know Supabase accepts.
 * Anything else (spaces, colons — which also catches legacy `blob:` URLs
 * persisted as keys) means the key can never have been accepted by storage,
 * so regenerating it cannot orphan an uploaded object or duplicate a row.
 */
export const isValidStorageKey = (key: string): boolean => /^[\w!.*'()/-]+$/.test(key)
